// @ts-strict-ignore
import {HttpEventType} from "@angular/common/http";
import {AfterViewInit, Component, ElementRef, Injector, ViewChild} from "@angular/core";
import {ApiError, MediaType} from "@models";
import {TranslateService} from "@ngx-translate/core";
import {NotificationService, SimUploadService, SimUtilityService} from "@services";
import {Translations} from "@translations";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_ImportLibraryArchiveDialogInput extends MatDialogDataBaseInput {
	archiveType: "Scenario" | "Marker" | "Checklist" | "VOG" | "Media" | "VOP" | "Assessment";
}

export interface DialogData_ImportLibraryArchiveDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-import-library-archive-dialog",
	templateUrl: "./import-library-archive-dialog.component.html",
	styleUrls: ["./import-library-archive-dialog.component.scss"],
	standalone: false,
})
export class ImportLibraryArchiveDialogComponent
	extends BasicMaterialDialog<
		ImportLibraryArchiveDialogComponent,
		DialogData_ImportLibraryArchiveDialogInput,
		DialogData_ImportLibraryArchiveDialogOutput
	>
	implements AfterViewInit
{
	T = Translations;

	MediaType = MediaType;
	SimUtilityService = SimUtilityService;
	afterViewInit: boolean;

	@ViewChild("uploadInput", {static: false}) uploadInput: ElementRef;
	currentSelectedFile: File;
	public uploadedFiles: boolean = false;

	constructor(
		private _simNotificationService: NotificationService,
		private _simUploadService: SimUploadService,
		private _translate: TranslateService,
		_injector: Injector,
	) {
		super(_injector);
	}

	ngAfterViewInit() {
		this.afterViewInit = true;
	}

	chooseFiles() {
		if (!this.currentSelectedFile) {
			this.uploadInput.nativeElement.click();
		} else {
			this.currentSelectedFile = undefined;
			this.uploadInput.nativeElement.value = "";
			this.uploadInput.nativeElement.click();
		}
	}

	handleFileInput(event: Event) {
		const files = (event.target as HTMLInputElement).files;

		if (files?.length === 0) {
			this._simNotificationService.notifyInfo(this._translate.instant(this.T.EVENT_CREATION_ATTACHMENT_DIALOG_NOTIFYERROR));
			this.currentSelectedFile = undefined;
			return;
		}

		this.currentSelectedFile = files.item(0);
	}

	uploadFiles() {
		this._simUploadService
			.uploadZipFile({
				uploadedFile: this.currentSelectedFile,
				type: this.data.archiveType,
			})
			.subscribe({
				next: (response) => {
					if (response.type === HttpEventType.Response) {
						if (response.body.success) {
							this._simNotificationService.notifySuccess();
						} else {
							this._simNotificationService.notifyError(response.body.reason);
						}
					}

					if (response.type === HttpEventType.UploadProgress) {
						//file.progressUploading = Math.round(100 * response.loaded / response.total);
					}
				},
				error: (err: ApiError) => {
					if (!err.wasLogged) {
						this._simNotificationService.notifyError("Could not upload file!");
					}
				},
				complete: () => {
					this.close({action: "ok"});
				},
			});
	}
}
